import { render, staticRenderFns } from "./ProfileAddAttention.vue?vue&type=template&id=5ce97134&scoped=true&"
import script from "./ProfileAddAttention.vue?vue&type=script&lang=js&"
export * from "./ProfileAddAttention.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAddAttention.vue?vue&type=style&index=0&id=5ce97134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce97134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ce97134', component.options)
    } else {
      api.reload('5ce97134', component.options)
    }
    module.hot.accept("./ProfileAddAttention.vue?vue&type=template&id=5ce97134&scoped=true&", function () {
      api.rerender('5ce97134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/add_attention/ProfileAddAttention.vue"
export default component.exports